import { hubShiftsIntlIds } from './hub-shifts.ids';

export const hubShiftsLangEnUs = {
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.date]: 'Date',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.shift]: 'Shift',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.assignRider]: 'Assign',
  [hubShiftsIntlIds.hubShiftsList.table.cell.body.shift]:
    '{startTime} to {endTime}',

  [hubShiftsIntlIds.assignRiderToHubShiftModal.trigger.openModalButton.label]:
    'Assign Rider',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.title]:
    'Confirm assignment of the Rider?',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.closeIconButton.label]:
    'Close',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.description]:
    'By confirming, a <highlight>shift slot for {shiftName}, on {shiftDate}, from {shiftStartsAt} to {shiftEndsAt}</highlight>, will be automatically assigned to the selected Rider.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.reviewBeforeConfirming]:
    'Please review before confirming.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.placeholder]:
    'Select or search by Rider ID',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .label]: `ID {riderId}: {riderName} • {medal, select,
      gold {Gold}
      silver {Silver}
      bronze {Bronze}
      other {}
    } • {modality, select,
      bicycle {Bicycle}
      motorcycle {Motorcycle}
      other {}
    }`,
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .noRidersAvailable.label]: 'No Riders available',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.allSlotsTaken.label]:
    '<highlight>Period expired!</highlight> All positions for this period have already been reserved. To complete the assignment, choose another shift.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.overlappingBooking
    .label]:
    'This person already has a confirmed slot in the <highlight>{shiftName} shift ({shiftStartsAt} to {shiftEndsAt})</highlight>, which conflicts with this one. Choose another shift to avoid conflicts.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.cancelButton.label]:
    'Cancel',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.confirmAndAssignButton
    .label]: 'Confirm and assign',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.title]:
    'Slot successfully assigned!',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.description]:
    'The Rider will be notified about the change',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.title]:
    'Error assigning the slot!',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.description]:
    'Please try again',
};
